import moment from "moment";
import { capitalize } from "../../common/utils/methods/commonMethods/utilityMethod";
import { LastUpdatedDetails } from "../../employeeManagement/userProfile/helper";
import { getProgramActionViewIcon } from "../studentDetails/programActionUpdate/hook";
import { getCourseIdDetailIcon } from "./common";

export const detailsRowStyles = {
  fontSize: "14px",
  color: "#0F0F0F",
  marginBottom: "1rem",
};
export const linkButtonStyles = {
  fontSize: "16px",
  color: "#00B0F5",
  fontWeight: "600",
  cursor: "pointer",
  marginBottom: "0.5rem",
};
export const iconStyles = { cursor: "pointer", color: "#000000" };
export const disabledIconStyles = { color: "#00000042" };

export const academicCardInfoLabels = (requireApplicationId = true,programActionHistory,courseIdDetail) => [
  ...(requireApplicationId ? [{ title: "ID", objKey: "applicationId" }] : []),
  { title: "Roll No.", objKey: "rollNumber" },
  { title: "Term", objKey: "termDispVal" },
  { title: "Program Action", objKey: "programActions", isShowToolTip: true,renderRight: (value) =>
      getProgramActionViewIcon(value, programActionHistory) },
  { title: "Academic Group", objKey: "academicGroup" },
  {
    title: "Registration Date",
    objKey: "registrationDate",
    valueGetter: (o) =>
      o?.registrationDate
        ? new moment(o?.registrationDate).format("DD-MM-YYYY")
        : "-",
  },
  { title: "Course", objKey: "courseId", renderRight: (value) =>
      getCourseIdDetailIcon(courseIdDetail) },
  // {title:'Roll Number' , objKey: 'rollNumber'},
  { title: "Class", objKey: "classes" },
  { title: "Business Area", objKey: "businessAreaDispValue" },
  { title: "Opportunity Owner Id", objKey: "opportunityOwnerId" },
  { title: "Modification Count", objKey: "modifyCount" },
  { title: "Enrolment Type", objKey: "enrollmentType" },
  // { title: "Admission Form", objKey: "marksheetAndAdmissionKey" }, //moved in "Form Management Section"
];

export const batchCardInfoLables = {
  current: [
    { title: "Application ID", objKey: "applicationId" },
    {
      title: "Enrollment",
      objKey: "enrollmentStatus",
      valueGetter: (o) => capitalize(o?.["enrollmentStatus"]),
    },
    {
      title: "Allocated Date",
      objKey: "allocationDate",
      valueGetter: (o) =>
        o?.allocationDate
          ? new moment(o?.allocationDate).format("DD-MMM-YYYY")
          : null,
    },
    {
      title: "Current Strength/Total Capacity",
      objKey: "currentStrength",
      valueGetter: (o) => `${o?.["currentStrength"]}/${o?.["totalCapacity"]}`,
    },
    {
      title: "Last Updated On/By",
      objKey: "updatedOn",
      valueGetter: (o) => LastUpdatedDetails(o["updatedOn"], o["updatedBy"]),
    },
  ],
  past: [
    { title: "Application ID", objKey: "applicationId" },
    {
      title: "Enrollment",
      objKey: "enrollmentStatus",
      valueGetter: (o) => capitalize(o?.["enrollmentStatus"]),
    },
    {
      title: "Allocated Date",
      objKey: "allocationDate",
      valueGetter: (o) =>
        o?.allocationDate
          ? new moment(o?.allocationDate).format("DD-MMM-YYYY")
          : null,
    },
    {
      title: "Deallocated Date",
      objKey: "deallocationDate",
      valueGetter: (o) =>
        o?.deallocationDate
          ? new moment(o?.deallocationDate).format("DD-MMM-YYYY")
          : null,
    },
    // { title: 'Deallocation Reason', objKey: 'deallocationReason' },
    {
      title: "Current Strength/Total Capacity",
      objKey: "currentStrength",
      valueGetter: (o) => `${o?.["currentStrength"]}/${o?.["totalCapacity"]}`,
    },
    {
      title: "Last Updated On/By",
      objKey: "updatedOn",
      valueGetter: (o) => LastUpdatedDetails(o["updatedOn"], o["updatedBy"]),
    },
  ],
};
